module.exports = __webpack_public_path__ + "img/icon-warning-vind-2.0d82c850.svg";